import React from 'react';
import bugsnagClient from 'utils/bugsnag';
import styles from './styles.module.scss';

const reactPlugin = bugsnagClient.getPlugin('react');

class DevErrorBoundary extends React.Component<
  { children?: React.ReactNode; FallbackComponent?: React.ComponentType },
  { hasError: boolean }
> {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    const { children, FallbackComponent } = this.props;
    if (this.state.hasError) return FallbackComponent ? <FallbackComponent /> : null;
    return children ?? null;
  }
}

const ErrorBoundary = reactPlugin ? reactPlugin.createErrorBoundary(React) : DevErrorBoundary;

export default ErrorBoundary;

export const DefaultFallbackComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.description}>
        <p>アプリケーションエラーにより表示できません。</p>
        <p>時間を置いて更新してください。</p>
      </div>
    </div>
  );
};
